import React, { memo, useMemo } from "react";
import {
  makeStyles,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import grey from "@material-ui/core/colors/grey";

import { Text, View } from "../../../components/Base";
import {
  DEPOT_NUMBER,
  NO_PARCELS_FOUND,
  ROUTE,
} from "../../../constants/strings";
import palette from "../../../components/styles/palette";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    overflowY: "auto",
    height: typography.pxToRem(206),
  },
  errorText: {
    fontSize: typography.pxToRem(12),
    color: palette.dpdRed,
  },
  headerRow: {
    backgroundColor: grey["200"],
  },
  headerCell: {
    fontWeight: 500,
    fontSize: typography.pxToRem(12),
    lineHeight: typography.pxToRem(14),
    textTransform: "capitalize",
    color: "black",
    boxSizing: "border-box",
    padding: `${typography.pxToRem(13)} ${typography.pxToRem(10)}`,
    width: "50%",
  },
  bodyCell: {
    fontWeight: "normal",
    fontSize: typography.pxToRem(12),
    lineHeight: typography.pxToRem(14),
    boxSizing: "border-box",
    padding: `${typography.pxToRem(4)} ${typography.pxToRem(10)}`,
  },
}));

const ParcelSearchResult = ({ results, errors }) => {
  const classes = useStyles();

  const content = useMemo(() => {
    if (!!errors.parcelError) {
      return <Text className={classes.errorText}>{errors.parcelError}</Text>;
    } else if (!results) {
      return null;
    } else if (!results.length) {
      return <Text className={classes.errorText}>{NO_PARCELS_FOUND}</Text>;
    } else {
      return (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow className={classes.headerRow}>
                <TableCell className={classes.headerCell}>
                  {DEPOT_NUMBER}
                </TableCell>
                <TableCell className={classes.headerCell}>{ROUTE}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {results.map(({ depotCode, routeCode }, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.bodyCell}>
                    {depotCode}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {routeCode}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  }, [classes, results, errors]);

  return <View className={classes.container}>{content}</View>;
};

export default memo(ParcelSearchResult);
